import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { getTheme } from 'utils/components';

export const APP_NAME = 'Arbor Idiomas';
export const APP_PREFIX_PATH = '/';
export const AUTH_PREFIX_PATH = '/login';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: getTheme() || 'light',
	direction: DIR_LTR
};
